import { defineMessages } from '@jutro/locale';

export default defineMessages({
    riskAnalysis: {
        id: 'portal.components.wizardSidebar.Risk Analysis',
        defaultMessage: 'Risk Analysis'
    },
    producerCode: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Producer Code',
        defaultMessage: 'Producer Code'
    },
    updateProducerCode: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Update Producer Code',
        defaultMessage: 'Update Producer Code'
    },
    rename: {
        id: 'quoteandbind.common.directives.templates.wizard-sidebar-additional.Rename',
        defaultMessage: 'Rename'
    },
    nameQuote: {
        id: 'quoteandbind.common.directives.templates.wizard-sidebar-additional.Name this quote',
        defaultMessage: 'Name this quote'
    },
    addNote: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Add Note',
        defaultMessage: 'Add Note'
    },
    autoQuote: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Auto Quote',
        defaultMessage: 'Auto Quote'
    },
    umbrellaQuote: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Umbrella Quote',
        defaultMessage: 'Umbrella Quote'
    },
    hoTypeHome: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Home Quote',
        defaultMessage: 'Home Quote'
    },
    hoTypeRent: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Renters Quote',
        defaultMessage: 'Renters Quote'
    },
    hoTypeCondo: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Condo Quote',
        defaultMessage: 'Condo Quote'
    },
    hoTypeLandlordCondo: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Landlord Condo Quote',
        defaultMessage: 'Landlord Condo Quote'
    },
    hoTypeLandlordHome: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Landlord Home Quote',
        defaultMessage: 'Landlord Home Quote'
    },
    editEffectiveDate: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Edit Effective Date',
        defaultMessage: 'Edit Effective Date'
    },
    effectiveDate: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Effective Date',
        defaultMessage: 'Effective Date'
    },
    policyNumber: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.#PolicyNumber',
        defaultMessage: 'Policy #{policyNumber}'
    },
    typePolicy: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Type Policy',
        defaultMessage: 'Policy'
    },
    viewRiskAnalysis: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.View Risk Analysis',
        defaultMessage: 'View Risk Analysis'
    },
    nameThisQuote: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Name this quote',
        defaultMessage: 'Name this quote'
    },
    renameThisQuote: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Rename this quote',
        defaultMessage: 'Rename this quote'
    },
    quoteName: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Quote Name',
        defaultMessage: 'Quote Name'
    },
    save: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Cancel',
        defaultMessage: 'Cancel'
    },
    cancellationTypePolicy: {
        id: 'cancellation.controllers.MLBaseCancellationWizardCtrl.Type Policy',
        defaultMessage: '{policyType} Policy'
    },
    discardAllChanges: {
        id: 'cancellation.views.ml-base-cancellation-wizard.DISCARD ALL CHANGES',
        defaultMessage: 'DISCARD ALL CHANGES'
    },
    confirmationTitle: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    deleteConfirmationTitle: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Delete change',
        defaultMessage: 'Delete change'
    },
    confirmationDesc: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Are you sure you want to cancel this policy change?',
        defaultMessage: 'Are you sure you want to cancel this policy change?'
    },
    deleteConfirmationDesc: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.Are you sure you want to delete this change?',
        defaultMessage: 'Are you sure you want to delete this change?'
    },
    yes: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.YES',
        defaultMessage: 'YES'
    },
    delete: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.DELETE',
        defaultMessage: 'DELETE'
    },
    endorsementCancel: {
        id: 'ml.endorsement.views.ml-base-endorsement-wizard.CANCEL',
        defaultMessage: 'CANCEL'
    },
    producerEligibilityError: {
        id: 'ml.agent.directives.ml-new-quote.Please try selecting a different producer code',
        defaultMessage: 'Please try selecting a different producer code'
    },
    requoteTitle: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Requote',
        defaultMessage: 'Requote'
    },
    requoteAuto: {
        id: 'ml.quoteandbind.views.ml-rename-quote-dialog.Requote the auto before adding the umbrella',
        defaultMessage: 'Requote the auto before adding the umbrella'
    },
    needIndicativeQuote: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.needIndicativeQuote',
        defaultMessage: 'Need {quotePrefix} {quoteName} Policy?'
    },
    needUmbrella: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Need an Umbrella?',
        defaultMessage: 'Need an Umbrella Policy?'
    },
    addUmbrella: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Add Umbrella',
        defaultMessage: 'Add Umbrella'
    },
    goToSpeciality: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.goToSpeciality',
        defaultMessage: 'Go to Specialty'
    },
    estimatedPremium: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Estimated Premium',
        defaultMessage: 'Estimated Premium'
    },
    estimatedPremiumMessage: {
        id: 'ml.agent.quoteandbind.common.controllers.BaseQnbWizard.Estimate based on assumed data and subject to change',
        defaultMessage: '*Estimate based on assumed data and subject to change.'
    },
    indicativeResponseError: {
        id: 'ml.gateway.quoteandbind.common.prefill.indicativeResponseError',
        defaultMessage: 'We are unable to retrieve an indicative quote at this time. Please go to ForemostSTAR® for a full rate quote.'
    }
});